module.exports = __webpack_public_path__ + "static/img/7.5711fb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/7.png
// module id = 8JOo
// module chunks = 0